import React from 'react';

const SectionHeaderTypes = {
    Primary: 'primary',
    Secondary: 'secondary'
}

function SectionHeader({ sectionHeaderType = SectionHeaderTypes.Primary, classes, children }) {
    let sectionHeaderTypeClasses;
    switch (sectionHeaderType) {
        case SectionHeaderTypes.Secondary:
            sectionHeaderTypeClasses = "h-8 bg-drhPalette-secondary";
            break;
        case SectionHeaderTypes.Primary:
        default:
            sectionHeaderTypeClasses = "h-11 bg-drhPalette-primary";
            break;
    }

    return (<div className={`flex flex-none items-center px-1.5 font-bold text-drhPalette-light ${sectionHeaderTypeClasses} ${classes}`}>
        {children}
    </div>);
}

export { SectionHeader as default, SectionHeaderTypes }